module.exports = {"ATTRIBUTES":[{"key":"integration_beden","title":"Beden","label":"product.attributes_kwargs.beden.label"},{"key":"integration_renk","title":"Renk","label":"product.attributes_kwargs.renk.label"}]}


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/integrationMaps/basket.json
// module id = 1427
// module chunks = 1